import { ChangeDetectorRef, Directive, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { LazyStylesService, type LazyStylesheet } from '@cue/lazy-styles';

const ASSIST_QUILL_STYLES: readonly LazyStylesheet[] = [{ id: 'assist-quill-css', href: 'quill-css.css' }];

@Directive({
  selector: '[quillLoad]',
  standalone: true,
})
export class QuillLoadDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private cdr = inject(ChangeDetectorRef);
  private lazyStyles = inject(LazyStylesService);

  async ngOnInit(): Promise<void> {
    await Promise.all([
      this.lazyStyles.loadMany(ASSIST_QUILL_STYLES),
      import(/* webpackPrefetch: true */ 'quill/dist/quill'),
    ]);
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.cdr.markForCheck();
  }
}
